"use client"

import { useEffect } from "react"
import { Ccm19EmbeddingName } from "src/integrations/ccm19/embeddings"
import { useCcm19EmbeddingAccepted } from "src/integrations/ccm19/useConsented"
import { usePosthogWeb } from "src/integrations/posthog/client-web"

export const PosthogIntegration = () => {
  const consented = useCcm19EmbeddingAccepted(Ccm19EmbeddingName.Posthog)
  const posthog = usePosthogWeb()

  useEffect(() => {
    if (consented) {
      posthog?.opt_in_capturing()
    } else {
      posthog?.opt_out_capturing()
    }
  }, [consented, posthog])

  return null
}
